/**
 * @generated SignedSource<<9beba2f6a4db02455f8aaa30c7c8a256>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CreateCustomSkillInput = {
  clientMutationId?: string | null | undefined;
  industryIds: ReadonlyArray<string>;
  name: string;
};
export type useSkillSuggestionsForm_CreateCustomSkillMutation$variables = {
  input: CreateCustomSkillInput;
};
export type useSkillSuggestionsForm_CreateCustomSkillMutation$data = {
  readonly createCustomSkill: {
    readonly skill: {
      readonly id: string;
      readonly industries: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }> | null | undefined;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type useSkillSuggestionsForm_CreateCustomSkillMutation = {
  response: useSkillSuggestionsForm_CreateCustomSkillMutation$data;
  variables: useSkillSuggestionsForm_CreateCustomSkillMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateCustomSkillPayload",
    "kind": "LinkedField",
    "name": "createCustomSkill",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Skill",
        "kind": "LinkedField",
        "name": "skill",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Industry",
            "kind": "LinkedField",
            "name": "industries",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useSkillSuggestionsForm_CreateCustomSkillMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useSkillSuggestionsForm_CreateCustomSkillMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "8c1694431a0f5c0e70d67a85651d9256",
    "id": null,
    "metadata": {},
    "name": "useSkillSuggestionsForm_CreateCustomSkillMutation",
    "operationKind": "mutation",
    "text": "mutation useSkillSuggestionsForm_CreateCustomSkillMutation(\n  $input: CreateCustomSkillInput!\n) {\n  createCustomSkill(input: $input) {\n    skill {\n      id\n      name\n      industries {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4dc36da68c201147e152cf4bc464fe6b";

export default node;
